(function () {
    angular
        .module('sodCommon')
        .filter('objWithoutKeys', objWithoutKeys);

    function objWithoutKeys(lodash) {
        return function (data, keys) {
            return lodash.reduce(data, function(carry, _data, _key) {
                if (lodash.indexOf(keys, _key) < 0) {
                    carry[_key] = _data;
                }
                return carry;
            }, {});
        };
    }
})();